import { DateFormats, formatDate } from '@strata/helper-functions';
import { InlineMessage } from '@strata/react-inline-message';
import { ReferralTimeline } from '@strata/react-timeline';
import dayjs from 'dayjs';

/** Returns an inline message if the referral has a future outreach date */
const prospectiveReferralInlineMessage = ({ outreachDate, referralStart }) =>
    dayjs().isBefore(referralStart) && outreachDate != null ? ( // Ignore when outreach date is null for now
        <InlineMessage
            key="prospectiveReferralInlineMessage"
            intent={InlineMessage.Intent.WARNING}
            label={`Servicing of this upcoming referral cannot begin until the servicing start date of ${formatDate(referralStart, DateFormats.DATE_MEDIUM)}. Prescriber and member outreach can begin ${dayjs().isBefore(outreachDate) ? formatDate(outreachDate, DateFormats.DATE_MEDIUM) : 'now'}.`}
            wrapText
        />
    ) : null;

/** Returns an inline message if the referral is lite */
const liteReferralInlineMessage = ({ lite }) =>
    lite ? (
        <InlineMessage
            key="liteReferralInlineMessage"
            intent={InlineMessage.Intent.INFO}
            label="This referral is being serviced by an FMH Lite supplier."
            wrapText
        />
    ) : null;

/** Returns an inline message if the referral has been transferred to a new segment */
const transferredSegmentInlineMessage = ({ enrichedMilestones }) => {
    const transferredSegmentName = enrichedMilestones?.find(
        (milestone) =>
            milestone.milestone_type === ReferralTimeline.MilestoneTypes.TREATMENT_SEGMENT_SWITCHED,
    )?.additional_data?.new_segment_name;

    return transferredSegmentName ? (
        <InlineMessage
            key="transferredSegmentInlineMessage"
            intent={InlineMessage.Intent.INFO}
            label={`Member's group coverage has changed, and has been transferred to the business segment ${
                transferredSegmentName
            }. Information on this page may be out of date.`}
        />
    ) : null;
};

export const getReferralInlineMessages = ({
    referralDetails = undefined,
    enrichedMilestones = undefined,
}) => {
    const inlineMessages = [
        prospectiveReferralInlineMessage({
            outreachDate: referralDetails?.outreachDate,
            referralStart: referralDetails?.referralStart,
        }),
        liteReferralInlineMessage({ lite: referralDetails?.lite }),
        transferredSegmentInlineMessage({ enrichedMilestones }),
    ];

    /** Ensure at least one inline message is defined before rendering container div */
    const showInlineMessages = inlineMessages.some((message) => message !== null);

    return showInlineMessages ? (
        <div className="flex__gap--medium" style={{ flexDirection: 'column', flexGrow: 1 }}>
            {inlineMessages}
        </div>
    ) : null;
};
